import { useState } from "react";
import { MapPin, Truck } from "lucide-react";
import axios from "axios";
import Swal from "sweetalert2";

export default function PincodeChecker() {
  const [pincode, setPincode] = useState("");
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

const handlePincode = async () => {
if (pincode.length !== 6) {
  Swal.fire({
    icon: "warning",
    title: "Invalid Pincode",
    text: "Please enter a valid 6-digit pincode.",
    confirmButtonText: "OK",
  });

  return;
}

  try {
    setLoading(true);

    const { data } = await axios.post(
      "https://tyka.premierhostings.com/beta/api/delivery-estimater",
      { pincode }
    );

    if (data.success && data.data?.success) {
      setResult({
        available: true,
        warehouse: data.data.warehouse,
        customerAddress: data.data.customer_address,
        distance: data.data.distance_km,
        days: data.data.estimated_days,
        estimatedDate: data.data.estimated_delivery,
      });
    } else {
      setResult({
        available: false,
        message: data.message || "Delivery not available",
      });
    }
  } catch (error) {
    console.error(error);

    setResult({
      available: false,
      message:
        error.response?.data?.message || "Something went wrong",
    });
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="rounded-xl bg-white shadow-sm">
      <h3 className="flex items-center gap-2 text-lg font-semibold">
        <MapPin size={18} />
        Check Delivery Estimate
      </h3>

      <div className="flex gap-2 mt-2">
        <input
          type="text"
          maxLength={6}
          value={pincode}
          onChange={(e) =>
            setPincode(e.target.value.replace(/\D/g, ""))
          }
          placeholder="Enter Pincode"
          className="flex-1 border rounded-lg px-3 py-2 outline-none focus:ring-2 focus:ring-[#FF0009]"
        />

        <button
          onClick={handlePincode}
          disabled={loading}
          className="px-5 bg-[#FF0009] text-white rounded-lg"
        >
          {loading ? "Checking..." : "Check"}
        </button>
      </div>

      {result && (
        <div
          className={`mt-4 rounded-lg p-3 ${
            result.available
              ? "bg-green-50 border border-green-200"
              : "bg-red-50 border border-red-200"
          }`}
        >
          {result.available ? (
            <>
              <p className="flex items-center gap-2 text-green-700 font-semibold">
                <Truck size={18} />
                Delivery Available
              </p>

              <p className="mt-2">
                Estimated Delivery:
                <span className="font-semibold ml-1">
                  {result.estimatedDate}
                </span>
              </p>

              <p className="text-sm text-gray-500">
                Delivery in {result.days}-{result.days + 2} business day
                {result.days + 2 > 1 ? "s" : ""}
              </p>
            </>
          ) : (
            <p className="text-red-600 font-semibold">
              Delivery not available.
            </p>
          )}
        </div>
      )}
    </div>
  );
}